
import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';

///  import { environment } from '../../environments/environment';

import { environment } from '../../environments/environment';
//   private apiUrl = environment.apiUrl;

@Injectable()
export class UploadService {

    ///import { environment } from '../../../environments/environment';
  private apiUrl = environment.apiUrl;

constructor(private http: HttpClient) { }



/////////////////////////  ------------ UPLOAD  IMG/VCD   FILE ------------


uploadData(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  return this.http.post<any>(""+this.apiUrl+"/Image/UploadFile", data, {
    reportProgress: true,
    observe: 'events'
  });
}


//  uploadTransferProductData

uploadTransferProductData(data) {
  var httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
        'key': 'x-api-key',
        'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

    })
  };

  // return this.http.post<any>("http://localhost:49587/api/Bill/UploadTransferProduct", data 
  return this.http.post<any>(""+this.apiUrl+"/Bill/UploadTransferProduct", data
  
);
}


/////  BOOKING --------------
uploadBookingProductData(data) {
  var httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
        'key': 'x-api-key',
        'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

    })
  };

  // http://localhost:49587/   http://localhost:49587/
 //  return this.http.post<any>("http://localhost:49587/api/Bill/UploadRetailProduct", data 
return this.http.post<any>(""+this.apiUrl+"/Bill/UploadBookingProduct", data
  
);
}

uploadRetailProductData(data) {
  var httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
        'key': 'x-api-key',
        'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

    })
  };

       // http://localhost:49587/   http://localhost:49587/
      // return this.http.post<any>("http://localhost:58782/api/Bill/UploadRetailProduct", data 
     return this.http.post<any>(""+this.apiUrl+"/Bill/UploadRetailProduct", data
  
);
}

uploadWSProductData(data) {
  var httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
        'key': 'x-api-key',
        'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

    })
};

   // return this.http.post<any>("http://adminapinew.thenugabest.com:57597/api/Bill/UploadWSProduct", data
  return this.http.post<any>(""+this.apiUrl+"/Bill/UploadWSProduct", data

      // return this.http.post<any>(""+this.apiUrl+"/ItemBasic2_Variation/UploadRetailProduct", data
     //, {
    //  reportProgress: true,
   //  observe: 'events'
  //}


);
}

uploadVariationData(data) {
  var httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
        'key': 'x-api-key',
        'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

    })
};

 return this.http.post<any>(""+this.apiUrl+"/ItemBasic2_Variation/UploadFileVariation", data
//return this.http.post<any>("http://localhost:49587/api/ItemBasic2_Variation/UploadFileVariation", data
//  http://localhost:49587/

//return this.http.post<any>("http://adminapinew.thenugabest.com:57597/api/ItemBasic2_Variation/UploadFileVariation", data
  

//, {
  //  reportProgress: true,
 //  observe: 'events'
//}


);
}

uploadOfferData(data) {
  var httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
        'key': 'x-api-key',
        'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

    })
};
return this.http.post<any>(""+this.apiUrl+"/ItemBasic3_Offering/UploadFileOffer", data
     //,
    //{
   //  reportProgress: true,
  //  observe: 'events'  ,
 //  responseType: 'json'
//}
);
}


//////////////////////////////////////////////////



UploadFileOrderStatusUpdateData(data) {
  var httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
        'key': 'x-api-key',
        'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

    })
};
return this.http.post<any>(""+this.apiUrl+"/Bill/UploadFileOrderStatusUpdate", data

   //, {
  //  reportProgress: true,
 //  observe: 'events'
//}

);
}

UploadFileDealDayData(data) {
  var httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
        'key': 'x-api-key',
        'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

    })
};
return this.http.post<any>(""+this.apiUrl+"/ItemMasterBasic4_Dimension/UploadFileDealDayUpdate", data

   //, {
  //  reportProgress: true,
 //  observe: 'events'
//}

);
}




}
